import type { HtmlContent } from '@mawkaa/types';
import { Code } from 'lucide-react';

interface HtmlBlockProps {
  content: HtmlContent;
  isEditing?: boolean;
}

export function HtmlBlock({ content, isEditing }: HtmlBlockProps) {
  const { code = '' } = content;

  if (!code && isEditing) {
    return (
      <section className="px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-100 rounded-lg p-8 text-center">
            <Code className="w-12 h-12 mx-auto text-gray-400 mb-4" />
            <p className="text-muted-foreground">Bloc HTML personnalisé</p>
            <p className="text-sm text-muted-foreground mt-2">
              Ajoutez votre code HTML, CSS ou JavaScript
            </p>
          </div>
        </div>
      </section>
    );
  }

  if (!code) {
    return null;
  }

  // In edit mode, show preview warning
  if (isEditing) {
    return (
      <section className="px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="border-2 border-dashed border-yellow-400 rounded-lg p-2">
            <div className="bg-yellow-50 text-yellow-800 text-xs px-3 py-1 rounded mb-2 inline-flex items-center gap-1">
              <Code className="w-3 h-3" />
              Bloc HTML (aperçu)
            </div>
            <div dangerouslySetInnerHTML={{ __html: code }} />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div dangerouslySetInnerHTML={{ __html: code }} />
      </div>
    </section>
  );
}
